export const APP_URL = import.meta.env.VITE_APP_URL ?? "https://thaicopilot.com"

export const FAQ_DATA = [
  {
    question: "Do I need Thai friends to use this?",
    answer:
      "Not required, but helpful. You can also practice solo or record conversations with taxi drivers, restaurant staff, or anyone willing to chat. Community feature coming soon...",
  },
  {
    question: "Is this an app I download?",
    answer:
      "It's web-based for now. Just open in your phone's browser—no download needed. Works on iPhone and Android.",
  },
  {
    question: "Is ThaiCopilot free?",
    answer:
      "Yes — completely free right now. No credit card, no trial, no limits. We're focused on building something genuinely useful before thinking about monetization. Paid plans may come in the future, but for now, everything is on me, the sole builder.",
  },
  {
    question: "What if I'm a complete beginner?",
    answer:
      "Perfect! The best time to start is with your first real conversation. Even if you only know 10 words, you'll start building useful vocabulary immediately.",
  },
  {
    question: "How accurate are the corrections?",
    answer:
      "We use the same technology that powers Google Translate. I have tested it personally in real-life situations, and it's surprisingly good. You can always share the translations with your friends to verify accuracy.",
  },
  {
    question: "What happens to my audio recordings?",
    answer:
      "They're stored securely and only used to generate your transcripts and flashcards. We never share or sell your data. You can delete recordings anytime.",
  },
]
